import { render, staticRenderFns } from "./MoreButton.vue?vue&type=template&id=ee224b78&scoped=true&"
import script from "./MoreButton.vue?vue&type=script&lang=js&"
export * from "./MoreButton.vue?vue&type=script&lang=js&"
import style0 from "./MoreButton.vue?vue&type=style&index=0&id=ee224b78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee224b78",
  null
  
)

export default component.exports